// eslint-disable-next-line import/prefer-default-export

// export * from './FitchGroupFooter'

import loadable from '@loadable/component'

// eslint-disable-next-line import/prefer-default-export
export const FitchGroupFooter = loadable(() => import('./FitchGroupFooter'), {
  resolveComponent: (module) => module.FitchGroupFooter
})
